export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LotesList2.vue?vue&type=template&id=9afdaba6&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/LotesList2.vue?vue&type=template&id=9afdaba6&
// module id = null
// module chunks = 